import React, { useEffect, useState, useCallback } from 'react'
import { Box, Typography, Divider, Paper, Grid, Button, TextField
} from '@mui/material';
import { useSnackbar } from 'notistack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { createReferral, getReferralCode } from 'services/referral';
import { Stack } from '@mui/system';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const Referral = () => {

  const { enqueueSnackbar } = useSnackbar();
  const [referralCode, setReferralCode] = useState([]);
  const [earnReferralCode, setEarngReferralCode] = useState('');
  
  useEffect(() => {
    getReferralCodeNUmber();
  }, []);



  const getReferralCodeNUmber = useCallback(() => {
    getReferralCode().then(({response, error}) => {
      if(response){
        setReferralCode(response.referralCode);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);

  const onReffralCodeCopied = useCallback(() => {
    enqueueSnackbar('Referral copied to clipboard', {variant: 'info'});
  }, [enqueueSnackbar]);

  const saveReferralCode = useCallback(() => {
    if(earnReferralCode){
      createReferral({referralCode: earnReferralCode}).then(({response, error}) => {
        if(response){
          enqueueSnackbar((response?.message || error), {variant: 'success'});
        } else {
          setEarngReferralCode('')
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      });
    }else{
      enqueueSnackbar('Enter a referral code', {variant: 'error'})
    }
  }, [earnReferralCode, enqueueSnackbar]);

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Refer and Earn
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            <Typography  component="h6" variant="subtitle2" gutterBottom sx={{mb: 1,}}>
              Gift the perfect platform to manage Libraries/Coaching Centers/PGs to your friends. Assured rewards to you and your friends when they signup with WEBOOK Business.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} sx={{alignItems: 'center',display: 'flex'}}>
            <img
              src='/assets/images/referral.png'
              alt="Refer and Earn"
              loading="lazy"
              style={{width: '100%'}}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} >
            <Paper sx={{boxShadow: "rgb(58, 53, 65, 0.1) 0px 2px 10px 0px", p: 2, backgroundColor: '#f7f7f7'}}>
              <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} >
                <Grid  item xs={12} sm={12} md={12} xl={12} lg={12} justifyContent="space-between" >
                  <Stack spacing={2} direction="row" justifyContent="space-between">
                    <Typography  component="div" variant="h6" gutterBottom sx={{mb: 1,}}>
                      Your <span style={{color: '#f0a500'}}>Referral Code</span>
                    </Typography>
                    <Typography  component="div" variant="h6" gutterBottom sx={{mb: 1,}}>
                        <span style={{color: '#3a972d'}}>{referralCode}</span>
                        <CopyToClipboard text={referralCode} onCopy={onReffralCodeCopied}>
                          <ContentCopyIcon sx={{verticalAlign: 'sub', ml: 1, cursor: 'pointer'}}/>
                        </CopyToClipboard>
                    </Typography>
                  </Stack>
                </Grid>
               
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}  sx={{my: 2}}>
                  <Typography  component="div" variant="body2" gutterBottom sx={{mb: 1,}}>
                    Your rewards will be credited to your WEBOOK Business wallet within 24-48 hours of your referral's sign up and registration on We Secure.
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}  sx={{my: 2}}>
                  <Divider textAlign="center">I have referral code</Divider>
                  <Stack spacing={2} direction="row"  sx={{my: 2}}>
                    <Box>
                      <TextField
                        label="Referral Code"
                        id="referralCode"
                        size="small"
                        value={earnReferralCode}
                        onChange={(e) => {setEarngReferralCode(e.target.value)}}
                      />
                    </Box>
                    <Button color="secondary" sx={{textTransform: 'none', ml: 1 }} onClick={saveReferralCode}>Submit</Button>
                  </Stack>
                </Grid>

              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default React.memo(Referral);
